/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../app/base/base.service.ts" />
/// <reference path="../../app/login/login.model.ts" />

module Eseebase {
    export class OrganizationSettingsService {
        private features: CompanyFeatureList;
        public uiStyling: CompanyUIStylingList;
        constructor(private $http: ng.IHttpService, private $route: any, private baseService: BaseService, private $q: ng.IQService, private userService: UserService) { }

        public addSetting(companyNumber: string, associationNumber: string, name: string, value: string | boolean) {
            return this.baseService.post('setting/' + companyNumber + '/' + associationNumber, { "name": name, "value": value }).then(f => { return f.data });
        }

        public getSettings(companyNumber: string, organizationNumber: string) {
            return this.baseService.get('setting/' + companyNumber + '/' + organizationNumber + '/list').then(j => { return j.data });
        }

        public getFeatures(force?: boolean): ng.IPromise<CompanyFeatureList> {
            var deferred = this.$q.defer();
            var vm = this;
            if (this.features == null || force) {
                this.baseService.get('setting/{companyNumber}/features').then((data) => {
                    vm.userService.getUser().then((u: UserModel) => {
                        vm.features = new CompanyFeatureList(<CompanyFeatureViewModel[]>data.data, u.roles.indexOf('Angel') > -1);
                        deferred.resolve(vm.features);
                    });
                },
                (reason) => {
                    deferred.reject(reason);
                });
            }
            else {
                deferred.resolve(this.features);
            }
            return <ng.IPromise<CompanyFeatureList>>deferred.promise;
        }

        public getUIStyling(force?: boolean): ng.IPromise<CompanyUIStylingList>  {
            var deferred = this.$q.defer();
            var vm = this;
            if (this.uiStyling == null || force) {
                this.baseService.get('setting/{companyNumber}/uistyling').then((data) => {
                    var newUiStyling = new CompanyUIStylingList(<string[]>data.data);
                    if (JSON.stringify(vm.uiStyling) != JSON.stringify(newUiStyling)) {
                        vm.uiStyling = newUiStyling;
                        vm.$route.reload();
                    }
                    deferred.resolve(vm.uiStyling);
                },
                (reason) => {
                    deferred.reject(reason);
                });
            }
            else {
                deferred.resolve(this.uiStyling);
            }
            return <ng.IPromise<CompanyUIStylingList>>deferred.promise;
        }
    }

    OrganizationSettingsService.$inject = ['$http', '$route', 'BaseService', '$q', 'UserService'];
    angular
        .module('eseebase')
        .service('OrganizationSettingsService', OrganizationSettingsService);
}